<div *ngIf="labJob$ | async as labJob" class="layout-margin">
  <pr-lab-job-form
    [labJob]="labJob"
    [isEdit]="true"
    (submitted)="saveChanges($event)"
    (cancelled)="cancelled.emit()"
   />
</div>
